export const USA_TBD_SUPPLIER_ID = "tBfxF7rbQZYNBFL8dNcNE4";
export const CANADA_TBD_SUPPLIER_ID = "29TDACHNsKmwAwhro5VnMD";

export const TBD_SUPPLIER_IDS = [USA_TBD_SUPPLIER_ID, CANADA_TBD_SUPPLIER_ID];
